import { render, staticRenderFns } from "./ACollaboratorFilterBox.vue?vue&type=template&id=4474231a"
import script from "./ACollaboratorFilterBox.vue?vue&type=script&lang=js"
export * from "./ACollaboratorFilterBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports